@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

$input-color: rgba(255, 255, 255, 0.8);

.Input {
  height: 40px;
  width: 100%;
  padding: var(--cxy-spacing-3) var(--cxy-spacing-xsm);
  background-color: transparent;
  border: 1px solid var(--cxy-color-border-input);
  border-radius: var(--cxy-input-borderRadius, 9999px);
  color: $input-color;
  @include cxy.font-size('text-m');
  transition: all 0.2s ease-in-out;

  &::placeholder {
    color: var(--cxy-color-border-input);
  }

  &:focus {
    border-color: $input-color;
  }

  &:focus-visible {
    @include cxy.focus-ring;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.error {
    border-color: var(--cxy-color-error);

    &:focus {
      border-color: var(--cxy-color-error);
    }
  }
}

.InputWrapper {
  position: relative;
  width: 100%;
}

.ErrorIcon {
  position: absolute;
  right: var(--cxy-spacing-xxsm);
  top: 20px;
  transform: translateY(-50%);
  stroke: var(--cxy-color-text-default-placeholder);
  fill: var(--cxy-color-error);
  height: 30px;
  width: 30px;
}

.ErrorMessage {
  color: var(--cxy-color-error);
  font-size: var(--cxy-fontSize-s);
  margin-block: var(--cxy-spacing-xxxsm);
  padding-inline-start: var(--cxy-spacing-xxsm);
}
